import { useState, useEffect } from 'react'
import styles from '../../styles/admin/StudyContent.module.scss'
import CorrectAnswerMultiple from '../common/CorrectAnswerMultiple'
import ExplanationSection from '../common/ExplanationSection'
import ImageDropzone from '../common/ImageDropzone'
import FractionQuestionInput from '../common/FractionQuestionInput'

const QuizTypeA = ({
  question,
  questionImageFile,
  subQuestionImageFile,
  correctAnswers,
  checkedStates,
  explanation,
  explanationImageFile,
  className,
  onQuestionChange,
  onQuestionImageChange,
  onSubQuestionImageChange,
  onCorrectAnswersChange,
  onCheckedStatesChange,
  onExplanationChange,
  onExplanationImageChange,
  existingQuestionImageUrl,
  existingSubQuestionImageUrl,
  existingExplanationImageUrl,
  onExistingQuestionImageRemove,
  onExistingSubQuestionImageRemove,
  onExistingExplanationImageRemove,
  answerImageFiles,
  onAnswerImageFilesChange,
  answerType,
  existingAnswerImageUrls,
}) => {
  const [localQuestionUrl, setLocalQuestionUrl] = useState(
    existingQuestionImageUrl
  )
  const [localSubQuestionUrl, setLocalSubQuestionUrl] = useState(
    existingSubQuestionImageUrl
  )
  const [localExplanationUrl, setLocalExplanationUrl] = useState(
    existingExplanationImageUrl
  )

  useEffect(() => {
    setLocalQuestionUrl(existingQuestionImageUrl)
  }, [existingQuestionImageUrl])

  useEffect(() => {
    setLocalSubQuestionUrl(existingSubQuestionImageUrl)
  }, [existingSubQuestionImageUrl])

  useEffect(() => {
    setLocalExplanationUrl(existingExplanationImageUrl)
  }, [existingExplanationImageUrl])

  return (
    <div className={`${styles.quizTypeAContainer} ${className || ''}`}>
      <div className={styles.quizTypeAWrapper}>
        <FractionQuestionInput
          value={question}
          onChange={onQuestionChange}
          className={`${className} symbol-input`}
          label="Question"
        />

        <div className={styles.quizTypeBImagesWrapper}>
          <ImageDropzone
            imageFile={questionImageFile}
            onImageChange={onQuestionImageChange}
            existingImageUrl={localQuestionUrl}
            className={styles.quizTypeAImage}
            showLabel={true}
            label="Image 1"
            onExistingImageRemove={() => {
              setLocalQuestionUrl('')
              onExistingQuestionImageRemove()
            }}
          />
          {/* Image 2 — hidden, reserved for future expansion */}
          <div style={{ display: 'none' }}>
            <ImageDropzone
              imageFile={subQuestionImageFile || null}
              onImageChange={onSubQuestionImageChange}
              existingImageUrl={localSubQuestionUrl}
              className={styles.quizTypeAImage}
              showLabel={true}
              label="Image 2"
              onExistingImageRemove={() => {
                setLocalSubQuestionUrl('')
                onExistingSubQuestionImageRemove()
              }}
            />
          </div>
        </div>

        <CorrectAnswerMultiple
          values={correctAnswers}
          onValuesChange={onCorrectAnswersChange}
          checkedStates={checkedStates}
          onCheckedStatesChange={onCheckedStatesChange}
          label="Answer (5entries)"
          className={styles.quizTypeAAnswer}
          answerType={answerType}
          imageFiles={answerImageFiles}
          onImageFilesChange={onAnswerImageFilesChange}
          existingImageUrls={existingAnswerImageUrls}
        />

        <ExplanationSection
          explanation={explanation}
          onExplanationChange={onExplanationChange}
          explanationImageFile={explanationImageFile}
          existingImageUrl={existingExplanationImageUrl}
          onExplanationImageChange={onExplanationImageChange}
          onExistingImageRemove={() => {
            onExistingExplanationImageRemove()
          }}
          className={styles.quizTypeAExplanation}
        />
      </div>
    </div>
  )
}

export default QuizTypeA